import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/(main)/integrations/github/page.tsx")